import React from "react"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
// Components
import Button from "../Button/Button"
// Styles
import { Container, Info, Image } from "./PageImage.styles"

const PageImage = ({ item }) => {
   return (
      <Container>
         <Link to={item.link}>
            <Image src={item.img} />
            <Info>
               <Button text={item.title} />
            </Info>
         </Link>
      </Container>
   )
}

PageImage.propTypes = {
   item: PropTypes.object,
}

export default PageImage
